module.exports = __webpack_public_path__ + "img/23-1.2a8c8d34.png";